import { registerModal } from '@gluedigital/modal';
import { FormattedMessage } from 'react-intl';
import SelectUserFront from './SelectUserFront/SelectUserFront';

import './SelectUserModal.sass';

const SelectUserModal = () => {
	if (__DEV__) {
		return (
			<div id="select-user-modal" className="modal-content">
				<header id="select-user-modal-header">
					<h1>
						<span>
							<FormattedMessage id="select-user-modal.title" />
						</span>
					</h1>
				</header>
				<section>
					<SelectUserFront isModal />
				</section>
			</div>
		);
	}
};

registerModal('select-user-modal', SelectUserModal);
